import { Heading } from '@assembly-js/design-system';
import { ListItemText } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import { useFeatureFlags } from 'src/context';

import { defaultListItemStyles, DynamicListItem } from './DynamicListItem';

interface SidebarSectionTitleProps {
  htmlId: string;
  sectionTitle?: string;
}

export const SidebarSectionTitle: React.FC<SidebarSectionTitleProps> = ({
  htmlId,
  sectionTitle,
  children,
}) => {
  const { EnableNewSidebar } = useFeatureFlags();
  return (
    <DynamicListItem
      htmlId={htmlId}
      data-testid={htmlId}
      className={
        EnableNewSidebar ? undefined : clsx('py-2 pb-0', defaultListItemStyles)
      }
      button={false}
    >
      {EnableNewSidebar ? (
        <Heading size="xs" className="text-secondary">
          {sectionTitle}
        </Heading>
      ) : (
        <ListItemText
          primary={sectionTitle}
          classes={{
            root: 'my-0.5',
            primary: 'text-light-gray text-[12px] leading-[18px]',
          }}
        />
      )}
      {children}
    </DynamicListItem>
  );
};
